import { Check, Clock, X } from 'lucide-react';

export type StepState = 'done' | 'current' | 'rejected' | 'todo';
export type ProofStep = { label: string; sub?: string; state: StepState };

/**
 * The 3-dot "Paid → Proof → Credited" strip at the top of every unpaid-deposit
 * card. `data-progress` on the `<ol>` drives the two connector-line segments in
 * CSS (grey vs green) from a single number, so the stepper never has to know
 * about `::before`/`::after` geometry — it only counts how many steps are done.
 */
function dotIcon(state: StepState) {
  if (state === 'done') return <Check size={14} aria-hidden="true" />;
  if (state === 'current') return <Clock size={14} aria-hidden="true" />;
  if (state === 'rejected') return <X size={14} aria-hidden="true" />;
  return null;
}

export function ProofStepper({ steps }: { steps: [ProofStep, ProofStep, ProofStep] }): JSX.Element {
  const progress = steps.filter((step) => step.state === 'done').length;
  return (
    <ol className="proof-stepper" data-progress={progress}>
      {steps.map((step, i) => (
        <li key={i} className={`proof-step is-${step.state}`} data-proof-step={i + 1} data-step-state={step.state}>
          <i className="proof-dot">{dotIcon(step.state)}</i>
          <span className="proof-step-label">{step.label}</span>
          <small className="proof-step-sub">{step.sub || ''}</small>
        </li>
      ))}
    </ol>
  );
}
